export function getQueryStringValue(key: string): string {
	return decodeURIComponent(
		window.location.search.replace(
			new RegExp(
				'^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$',
				'i'
			),
			'$1'
		)
	);
}
